
import React from "react";
import { AlertTriangle } from "lucide-react";

const UnAuthorizedPage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-sm">
       <AlertTriangle className="mx-auto text-red-500 w-16 h-16 mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Unauthorized Access
        </h2>
        <p className="text-gray-600 mb-4">
          You don’t have permission to access this page.
        </p>
      </div>
    </div>
  );
};

export default UnAuthorizedPage;
